
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dpbjJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0cfb1bd22cd0b0fb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $0cfb1bd22cd0b0fb$export$2e2bcd8739ae039 = {
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': "\u7531 Atlassian Intelligence \u63D0\u4F9B\u6280\u8853\u652F\u63F4",
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': "\u7531 AI \u63D0\u4F9B\u6280\u8853\u652F\u63F4",
    'fabric.editor.ai.commandPalette.footer.disclaimerText': "\u5167\u5BB9\u53D6\u6C7A\u65BC\u60A8\u7684\u6B0A\u9650\uFF0C\u5176\u54C1\u8CEA\u53EF\u80FD\u6703\u6709\u6240\u4E0D\u540C",
    'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': "\u5167\u5BB9\u54C1\u8CEA\u53EF\u80FD\u6703\u6709\u6240\u4E0D\u540C",
    'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': "\u4F7F\u7528\u4EBA\u5DE5\u667A\u6167\u3002\u9A57\u8B49\u7D50\u679C\u3002",
    'fabric.editor.ai.commandPalette.footer.infoIconLabel': "\u8CC7\u8A0A",
    'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
    'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': "\u5305\u542B\u76EE\u524D\u9801\u9762\u4E2D\u7684\u77E5\u8B58",
    'fabric.editor.ai.commandPalette.promptForm.logo': "Atlassian Intelligence \u6A19\u8A8C",
    'fabric.editor.ai.components.backIconButton.backLabel': "\u8FD4\u56DE",
    'fabric.editor.ai.components.cancelEscButton.cancelLabel': "\u53D6\u6D88",
    'fabric.editor.ai.components.cancelEscButton.escLabel': "\u96E2\u958B",
    'fabric.editor.ai.components.cancelIconButton.cancelLabel': "\u53D6\u6D88",
    'fabric.editor.ai.components.cancelIconButton.cancelTooltip': "\u53D6\u6D88",
    'fabric.editor.ai.components.feedbackForm.badResponse': "\u56DE\u61C9\u4E0D\u826F",
    'fabric.editor.ai.components.feedbackForm.feedbackSent': "\u5DF2\u50B3\u9001\u610F\u898B\u53CD\u61C9",
    'fabric.editor.ai.components.feedbackForm.goodResponse': "\u56DE\u61C9\u826F\u597D",
    'fabric.editor.ai.config.item.action.continueFromLatestResponse': "\u5F9E\u6700\u5F8C\u56DE\u61C9\u7E7C\u7E8C",
    'fabric.editor.ai.config.item.action.copyResponse': "\u8907\u88FD",
    'fabric.editor.ai.config.item.action.responseCopied': "\u5DF2\u8907\u88FD\uFF01",
    'fabric.editor.ai.config.item.action.responseCopiedToClipboard': "\u5DF2\u8907\u88FD\u5230\u526A\u8CBC\u7C3F",
    'fabric.editor.ai.config.item.action.retryPrompt': "\u91CD\u8A66",
    'fabric.editor.ai.experience-application.documentInsertError': "\u6211\u5011\u5728\u63D2\u5165\u56DE\u61C9\u6642\u9047\u5230\u554F\u984C\u3002\u8ACB\u95DC\u9589\u5C0D\u8A71\u65B9\u584A\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'fabric.editor.ai.experience-application.tokenLimitExceeded': "\u6211\u5011\u7121\u6CD5\u53D6\u5F97\u56DE\u61C9\u3002\u60A8\u7684\u63D0\u793A\u6216\u56DE\u61C9\u5DF2\u8D85\u904E\u6B64\u8981\u6C42\u7684\u9650\u5236\u3002\u8ACB\u95DC\u9589\u5C0D\u8A71\u65B9\u584A\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'fabric.editor.ai.experience.apiError': "\u6211\u5011\u7121\u6CD5\u6536\u5230\u56DE\u8986\uFF0C\u8ACB\u518D\u8A66\u4E00\u6B21\u3002",
    'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.commandPaletteV2Placeholder': "\u544A\u8A34 AI \u8981\u600E\u9EBC\u505A...",
    'fabric.editor.ai.experience.inputTooShortError': "\u5167\u5BB9\u592A\u77ED\uFF0C\u7121\u6CD5\u7E3D\u7D50\u3002\u8ACB\u65B0\u589E\u66F4\u591A\u5167\u5BB9\u4E26\u518D\u8A66\u4E00\u6B21\u3002",
    'fabric.editor.ai.experience.loadingAriaNewTitle': "\u5206\u6790\u4E2D",
    'fabric.editor.ai.experience.loadingAriaTitle': "\u6B63\u5728\u7522\u751F",
    'fabric.editor.ai.experience.loadingEditingTitle': "\u7DE8\u8F2F\u4E2D",
    'fabric.editor.ai.experience.previewScreenLabel': "\u9810\u89BD",
    'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder': "\u8ACB\u5BA2\u670D\u4EBA\u54E1\u64B0\u5BEB\u4EFB\u4F55\u5167\u5BB9\u6216\u5F9E\u4E0B\u65B9\u9078\u64C7",
    'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
    'fabric.editor.ai.experience.rovoAgents.productLogoAltText': "Rovo \u6A19\u8A8C",
    'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.discard.cancelLabel': "\u8FD4\u56DE",
    'fabric.editor.ai.screens.discard.discardLabel': "\u6368\u68C4",
    'fabric.editor.ai.screens.error.warningIconLabel': "\u8B66\u544A",
    'fabric.editor.ai.screens.error.ariaErrorTitle': "\u932F\u8AA4",
    'fabric.editor.ai.screens.error.cancelLabel': "\u53D6\u6D88",
    'fabric.editor.ai.screens.error.retryLabel': "\u518D\u8A66\u4E00\u6B21",
    'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': "\u5373\u6642\u66F4\u65B0\u7684\u5167\u5BB9\uFF1A",
    'fabric.editor.ai.screens.loading.iconAltText': "\u6B63\u5728\u7522\u751F\u5716\u793A",
    'fabric.editor.ai.screens.preview.actionButtonsAccept': "\u63A5\u53D7",
    'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': "\u4EBA\u5DE5\u667A\u6167\u751F\u6210\u5167\u5BB9\u7684\u52D5\u4F5C",
    'fabric.editor.ai.screens.preview.actionButtonsTryAgain': "\u518D\u8A66\u4E00\u6B21",
    'fabric.editor.ai.screens.preview.betaLabel': "\u6E2C\u8A66\u7248",
    'fabric.editor.ai.screens.preview.cancelLabel': "\u53D6\u6D88",
    'fabric.editor.ai.screens.preview.compactFeedbackText': "\u6709\u5E6B\u52A9\u55CE\uFF1F",
    'fabric.editor.ai.screens.preview.defaultAIPlaceholder': "\u544A\u8A34 AI \u4E0B\u4E00\u6B65\u8A72\u600E\u9EBC\u505A",
    'fabric.editor.ai.screens.preview.discardLabel': "\u6368\u68C4",
    'fabric.editor.ai.screens.preview.disclaimer': "\u8CC7\u8A0A\u54C1\u8CEA\u53EF\u80FD\u6703\u6709\u8B8A\u5316\u3002",
    'fabric.editor.ai.screens.preview.disclaimerLink': "\u4E86\u89E3\u539F\u56E0",
    'fabric.editor.ai.screens.preview.header.clear.hover': "\u6E05\u9664",
    'fabric.editor.ai.screens.preview.header.edit': "\u7DE8\u8F2F\u63D0\u793A",
    'fabric.editor.ai.screens.preview.header.edit.hover': "\u7DE8\u8F2F",
    'fabric.editor.ai.screens.preview.placeholderWithAgent': "\u8A62\u554F {agentName} \u63A5\u4E0B\u4F86\u8981\u505A\u4EC0\u9EBC",
    'fabric.editor.ai.screens.preview.refineButton': "\u5FAE\u8ABF",
    'fabric.editor.ai.screens.preview.refineDropdown.refineButton': "\u5FAE\u8ABF",
    'fabric.editor.ai.screens.prompt.logoAltText': "Atlassian Intelligence \u6A19\u8A8C",
    'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.prompt.submitLabel': "\u63D0\u4EA4",
    'fabric.editor.ai.screens.prompt.submitTooltip': "\u50B3\u9001\u81F3 AI",
    'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': "{promptName} - \u5DF2\u9078\u53D6",
    'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': "\u79FB\u9664",
    'fabric.editor.ai.shared.aiProactiveButtonLabel': "\u5EFA\u8B70",
    'fabric.editor.ai.shared.aiUniversalDescriptor': "\u5BEB\u4F5C\u52A9\u7406",
    'fabric.editor.ai.shared.aiUniversalLongCallToAction': "\u8B93 Atlassian Intelligence \u5354\u52A9\u60A8\u5BEB\u4F5C",
    'fabric.editor.ai.shared.aiUniversalShortCallToAction': "\u64B0\u5BEB",
    'fabric.editor.ai.shared.betaLabel': "\u6E2C\u8A66\u7248",
    'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
    'fabric.editor.ai.ui.components.suggestions.betaLozenge': "\u6E2C\u8A66\u7248",
    'fabric.editor.ai.ui.components.suggestions.newLozenge': "\u65B0\u529F\u80FD",
    'fabric.editor.ai.ui.components.suggestions.tellAILabel': "\u544A\u8A34 AI",
    'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': "\u544A\u8A34\u5BA2\u670D\u4EBA\u54E1"
};

});


//# sourceMappingURL=zh_TW.94d63ad3.js.map
